const md5 = require('js-md5');
//tencentAI开放平台
var app_key = "DlekR23sfAX3jS4P";
var app_id = 2117661949;

//字母排序：区分大小写
function sortCharter(a, b) {
    if (a.toString() > b.toString()) {
        return 1;
    } else if (a.toString() == b.toString()) {
        return 0;
    } else {
        return -1;
    }
}

function objKeySort(obj) { //排序的函数
    var newkey = Object.keys(obj).sort(sortCharter);
    //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    var newObj = {}; //创建一个新的对象，用于存放排好序的键值对
    for (var i = 0; i < newkey.length; i++) { //遍历newkey数组
        newObj[newkey[i]] = obj[newkey[i]]; //向新创建的对象中按照排好的顺序依次增加键值对
    }
    return newObj; //返回排好序的新对象
}
String.prototype.PadLeft = function(len, charStr) {
    var s = this + '';
    return new Array(len - s.length + 1).join(charStr, '') + s;
}

function urlencode(clearString) {
    var output = '';
    var x = 0;
    clearString = utf16to8(clearString.toString());
    var regex = /(^[a-zA-Z0-9-_.]*)/;
    while (x < clearString.length) {
        var match = regex.exec(clearString.substr(x));
        if (match != null && match.length > 1 && match[1] != '') {
            output += match[1];
            x += match[1].length;
        } else {
            if (clearString[x] == ' ')
                output += '+';
            else {
                var charCode = clearString.charCodeAt(x);
                var hexVal = charCode.toString(16);
                output += '%' + (hexVal.length < 2 ? '0' : '') + hexVal.toUpperCase();
            }
            x++;
        }
    }

    function utf16to8(str) {
        var out, i, len, c;
        out = "";
        len = str.length;
        for (i = 0; i < len; i++) {
            c = str.charCodeAt(i);
            if ((c >= 0x0001) && (c <= 0x007F)) {
                out += str.charAt(i);
            } else if (c > 0x07FF) {
                out += String.fromCharCode(0xE0 | ((c >> 12) & 0x0F));
                out += String.fromCharCode(0x80 | ((c >> 6) & 0x3F));
                out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
            } else {
                out += String.fromCharCode(0xC0 | ((c >> 6) & 0x1F));
                out += String.fromCharCode(0x80 | ((c >> 0) & 0x3F));
            }
        }
        return out;
    }
    return output;
}

//创建sign
function create_sign(data) {

    console.log("1、排序前create_sign");
    console.log(data);
    //1、排序
    data = objKeySort(data);
    console.log("1、排序后create_sign");
    console.log(data);
    //2.拼接
    var txt = "";
    var newkey = Object.keys(data);
    for (var i = 0; i < newkey.length; i++) { //遍历newkey数组
        txt += newkey[i] + "=" + urlencode(data[newkey[i]]) + "&";
    }
    //console.log(txt);
    //console.log("for内部===3.追加私钥appsecret");
    //3.追加私钥appsecret
    // console.log(txt);
    // console.log("appsecret=" + appsecret);
    txt = txt + "app_key=" + app_key;
    //4.md5加密
    txt = md5(txt);
    return txt.toUpperCase();
}

function randomString(len) {
    len = len || 10;
    var string = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
    var maxPos = string.length;
    var pwd = '';
    for (let i = 0; i < len; i++) {
        pwd += string.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

export function create_idcard_param(base64, card_type) {
    let param = {
        "app_id": app_id,
        "time_stamp": parseInt(Date.now() / 1000),
        "nonce_str": randomString(10),
        "image": base64,
        "card_type": card_type
    }
    param["sign"] = create_sign(param);
    return JSON.stringify(param);
}

export function create_general_param(base64) {
    let param = {
        "app_id": app_id,
        "time_stamp": parseInt(Date.now() / 1000),
        "nonce_str": randomString(10),
        "image": base64
    }
    param["sign"] = create_sign(param);
    return JSON.stringify(param);
}
